import { createRoot } from 'react-dom/client';

import ReduxProvider from '@common/providers/Redux/ReduxProvider';
import ThemeProvider from '@common/providers/Theme/ThemeProvider';

import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ReduxProvider>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </ReduxProvider>
);
